import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '18px',
    backgroundColor: 'common.lightGreen',
    borderRadius: '4px',
    mb: '10px',
  },
  subContainer: {
    display: 'flex',
  },
  basicContainer: {
    justifyContent: 'flex-end',
  },
  unlimitedContainer: {
    justifyContent: 'flex-start',
  },
  exportContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    my: '20px',
  },
  upperCard: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    pb: '17px',
    borderColor: 'common.border',
  },
  cancelStyle: {
    mb: '17px',
  },
  title: {
    fontWeight: '600',
    fontSize: 16,
  },
  caption: {
    fontSize: 14,
  },
  buttonText: {
    padding: 0,
    textDecoration: 'underline',
  },
  planFees: {
    fontSize: 32,
    fontWeight: '600',
    color: 'primary.main',
  },
  per: {
    fontSize: 14,
  },
  label: {
    color: 'grey.800',
  },
  compareContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '12px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
